import { createContext, useContext } from 'react'

import type { DrillRequest } from '../lib/filterTxns'

export interface DrillDownApi {
  openDrillDown: (request: DrillRequest) => void
}

export const DrillDownContext = createContext<DrillDownApi | null>(null)

export function useDrillDown(): DrillDownApi {
  const api = useContext(DrillDownContext)
  if (!api) throw new Error('useDrillDown must be used inside <DrillDownProvider>')
  return api
}
